import React, { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import store from "../../store/store";
import classNames from "classnames";
import styles from "./confirm.module.css";

// 工具类
export const Confirm = {
  show: (message, onConfirm, onClose) => {
    store.dispatch.confirm.show({
      message,
      onConfirm,
      onClose,
    });
  },
  hide: () => {
    store.dispatch.confirm.hide();
  },
};

const ConfirmComponent = () => {
  const { show, message, onConfirm, onClose } = useSelector(
    (state) => state.confirm
  );
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = useCallback(() => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      Confirm.hide();
      onClose?.();
    }, 600);
  }, [onClose]);

  const handleConfirm = useCallback(() => {
    onConfirm?.();
    handleClose();
  }, [onConfirm, handleClose]);

  if (!show) return null;

  return (
    <div
      className={classNames(
        styles.modalOverlay,
        isClosing && styles.modalClosing
      )}
    >
      <div
        className={classNames(styles.modal, isClosing && styles.modalClosing)}
      >
        <div className={styles.title}>请确认</div>
        <div className={styles.closeButton} onClick={handleClose} />
        <div className={styles.message}>{message}</div>
        <div className={styles.modalButtons}>
          <div className={styles.cancelButton} onClick={handleClose}>
            取消
          </div>
          <div className={styles.confirmButton} onClick={handleConfirm}>
            确认
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmComponent;
